import { Button } from "@newsela/angelou";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ActivityHeader from "@/view/ActivityHeader";
import { iconCss, rootCss } from "./ActivityPanelTab.style";

interface ActivityPanelTabProps {
  fitContent?: boolean | undefined;
  isArticle?: boolean | undefined;
  isStudent?: boolean | undefined;
  ref?: React.Ref<HTMLButtonElement> | undefined;
  onClick: (...args: unknown[]) => unknown;
}

const ActivityPanelTab = ({
  fitContent = false,
  isArticle = true,
  isStudent = false,
  onClick,
  ref,
}: ActivityPanelTabProps) => {
  return (
    <Button
      onClick={onClick}
      flavor={Button.flavors.incognito}
      __cssFor={{ root: rootCss(!isStudent, fitContent) }}
      ref={ref}
    >
      <ActivityHeader isStudent={isStudent} isArticle={isArticle} />
      <ChevronDownIcon css={iconCss} />
    </Button>
  );
};

export default ActivityPanelTab;
